import styled from "styled-components";

const colors = {
    positive: "#119C4A",
    negative: "#DD1F1F"
}

export const Tag = styled.div`
    padding: 4px 12px;
    line-height: 1.25;
    border-radius: 8px;
    background-color: ${props => props.type === 'positive' ? colors.positive : colors.negative}10;
    color: ${props => props.type === 'positive' ? colors.positive : colors.negative};
    border: 1px solid;
    font-weight: 500 !important;
    display: inline-flex;
    align-items: center;
    max-width: 130px;
    text-align: center;
    font-size: ${props => props.fontSize === 'small' ? 12 : 16}px;
    -webkit-user-select: none;
    -ms-user-select: none; 
    user-select: none; 
`;
